import { InjectionToken } from '@angular/core';
import { ISideEffectService } from './side-effect-service.interface';

export const SIDE_EFFECT_SERVICE = new InjectionToken<ISideEffectService>(
  'SIDE_EFFECT_SERVICE'
);
